'use strict';

var M = module.exports = require('./CalDate');
M.pad0 = require('./utils').pad0;
M.toNumber = require('./utils').toNumber;
M.isDate = require('./utils').isDate;
M.toYear = require('./utils').toYear;


//////////////////
// WEBPACK FOOTER
// ./~/caldate/lib/index.js
// module id = ./node_modules/caldate/lib/index.js
// module chunks = 0